query CspCampaignsIndex(
  $id: ID!
  $first: Int
  $last: Int
  $after: String
  $before: String
  $query: String
  $queryList: [QueryItemInput!]
) {
  cspCampaignsForAccount(
    accountId: $id
    first: $first
    last: $last
    after: $after
    before: $before
    query: $query
    queryList: $queryList
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        insertedAt
        updatedAt
        expiredAt

        active

        tcr_status
        auto_renewal

        origin_id

        tcr_csp_id
        tcr_brand_id
        tcr_campaign_id

        vertical
        usecase
        sub_usecases

        tcrResellerId

        description

        embedded_link
        embedded_phone
        number_pool
        age_gated
        direct_lending
        subscriber_optin
        subscriber_optout
        subscriber_help
        affiliate_marketing
        terms_and_conditions

        samples

        message_flow
        help_message
        help_keywords
        optin_message
        optin_keywords
        optout_message
        optout_keywords

        shared

        mnos {
          mno
        }

        brand {
          id
          displayName
        }

        account {
          id
          name
        }
      }
    }
  }
}
